import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { TextField, Box } from '@mui/material';
import TabFieldsMaintenance from '@/components/TabFieldsMaintenance/TabFieldsMaintenance';
import { fieldsTabsToBackKey } from '@/helpers/constants';
import { urlToTabKey } from '@/helpers/utils';
import { setDescriptionForms } from '@/redux/Forms/forms.action';
import { ReduxForms } from '@/types';

interface DescriptionFieldsMaintenanceProps {
  setFormsRedux: (forms: ReduxForms) => void;
}

const DescriptionFieldsMaintenance: React.FC<DescriptionFieldsMaintenanceProps> = (props) => {
  const { setFormsRedux } = props;
  const tab = urlToTabKey(fieldsTabsToBackKey);
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');

  const formsTitles = {
    source: `${t('description.trigger')}   ${t('description.source')}`,
    referenceSystem: t('involvedParties.referenceSystem'),
    inspectionType: `${t('description.inspectionAccordion')}   ${t('description.inspectionType')}`,
  };

  const mandatoryFieldsMap = {
    source: ['OTHER'],
    inspectionType: ['FUNCTIONAL', 'OTHER', 'TORQUE', 'VISUAL'],
  };

  return (
    <>
      <TabFieldsMaintenance
        tab={tab}
        setStateRedux={setFormsRedux}
        formsTitles={formsTitles}
        mandatoryFieldsMap={mandatoryFieldsMap}
      />
      <Box sx={{ display: 'flex', gap: 2, padding: 2, alignItems: 'center' }}>
        <TextField
          type="date"
          label={t('dateRangeFilter.from')}
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          size="small"
        />
        <span>–</span>
        <TextField
          type="date"
          label={t('dateRangeFilter.to')}
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          size="small"
        />
      </Box>
    </>
  );
};

const actionCreators = {
  setFormsRedux: setDescriptionForms,
};

export default connect(null, actionCreators)(DescriptionFieldsMaintenance);
